import { mergeNamespaceResources, sharedNamespaceResources } from './base.js'
import type { NamespaceResources, ResourceMap } from './base.js'

type LocaleModule = {
  default: ResourceMap
}

const localeModules = import.meta.glob<LocaleModule>('./apps/llm-web/locales/*/*.json', { eager: true })

const localResources = Object.entries(localeModules).reduce<NamespaceResources>((accumulator, [path, module]) => {
  const match = path.match(/\.\/apps\/llm-web\/locales\/([^/]+)\/([^/]+)\.json$/)
  if (!match) {
    return accumulator
  }

  const [, language, namespace] = match
  if (!accumulator[language]) {
    accumulator[language] = {}
  }

  accumulator[language][namespace] = module.default
  return accumulator
}, {})

export const llmNamespaceResources = mergeNamespaceResources(sharedNamespaceResources, localResources)